import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { IFetchMedicalNote, IMedicalNote } from '~/interfaces'
import { fetchMedicalNote, message } from '~/services'

const UNIQUE_KEY = 'medicalNote'

export const useFetchMedicalNote = (
  fetchParams: IFetchMedicalNote | null,
  config?: UseQueryOptions<IMedicalNote, Error, IMedicalNote>
): UseQueryResult<IMedicalNote, Error> => {
  const fetcher = async () => {
    if (!fetchParams) throw new Error('fetchParams is required')

    try {
      const response = await fetchMedicalNote(fetchParams)

      return response
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError?.code === '404') {
        throw new Error(message('detailsMedicalEvents.emptyResponseFetched'))
      }
      throw new Error(message('messages.genericUnexpectedError'))
    }
  }

  return useQuery<IMedicalNote, Error>([UNIQUE_KEY, fetchParams], fetcher, {
    cacheTime: Infinity,
    staleTime: Infinity,
    ...config
  })
}
